<template>
  <!-- HTML 정의하는 부분 -->
  <!-- 1차 퍼블리셔가 작업 영역 -->
  <!-- 2차 개발자가 Template 화 작업 진행-->
  <v-card class="card--group pa-4">
    <v-row v-if="from" class="pa-4">
      <v-text-field
        v-model="searchText"
        solo
        label="사이트명을 입력하세요"
        clearable
        hide-details
        @keyup.enter="searchSite"
      ></v-text-field>
      <v-btn color="#0784F2" height="48" @click="searchSite">
        <v-icon>
          mdi-magnify
        </v-icon>
      </v-btn>
    </v-row>
    <v-row>
      <v-col cols="6" class="pt-2 pb-1 pl-2 pr-1">
        <gauge-card :flag="refreshFlag" color="#90F072" :max="total.capacity" title="발전량" :value="total.pvpcsPac" unit="KW"></gauge-card>
      </v-col>
      <v-col cols="6" class="pt-2 pb-1 pl-1 pr-2">
        <gauge-card :flag="refreshFlag" color="#04B8FF" max=9 title="발전 시간" :value="total.time" unit="hr"></gauge-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-1 pb-1 pl-2 pr-1">
        <v-card height="150px" width="100%" rounded="lg">
          <v-card-title class="justify-center">
            당일 발전량
          </v-card-title>
          <v-spacer></v-spacer>
          <v-card-text class="text-center">
            <p class="site-card-pvpcs-dailyp ft">{{ total.pvpcsDailyP }}</p>
            <p class="site-card-unit">KWH</p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="pt-1 pb-1 pl-1 pr-2">
        <v-card height="150px" width="100%" rounded="lg">
          <img style="position:absolute;top:32%;left:6%;" :src="coinImg" alt="" />
          <v-card-title class="justify-center">
            당일 예상 금액
          </v-card-title>
          <v-card-text class="pt-8 text-right">
            <p class="site-card-total-price ft" >{{ total.price }}<span class="site-card-unit">&nbsp;&nbsp;원</span></p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="false">
      <v-col class="pt-1 pb-2 px-2">
        <v-card class="pa-1">
          <v-chart style="height: 200px;" :option="bar"></v-chart>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="popup" persistent max-width="450px" scrollable>
      <detail-status-popup @closeDetailPop="popup=false" :list="paramList" status="search" @siteName="emitSearchSite"></detail-status-popup>
    </v-dialog>
  </v-card>
</template>

<script>
// 스크립트를 정의하는 부분
// 개발자 작업 영역
// [ECMA6] export default 된 부분이 외부에서 import로 사용할 수 있게 된다.
import day from 'dayjs'
import DetailStatusPopup from '@/components/monitoring/DetailStatusPopup'
import { getSearchSite } from '@/api/monitoring/monitoring'
// import Message from '@/utils/Message'
import GaugeCard from '@/components/monitoring/GaugeCard'
import { CanvasRenderer } from 'echarts/renderers'
import { BarChart, GaugeChart } from 'echarts/charts'
import {
  DataZoomComponent,
  ToolboxComponent,
  GridComponent,
  VisualMapComponent,
  TimelineComponent,
  CalendarComponent,
  TooltipComponent
} from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'
import { use } from 'echarts/core'
import store from '@/store'

use([
  CanvasRenderer,
  BarChart,
  GaugeChart,
  DataZoomComponent,
  ToolboxComponent,
  GridComponent,
  VisualMapComponent,
  TimelineComponent,
  CalendarComponent,
  TooltipComponent
])

export default {
  // .vue 내부에서 사용되는 model
  // model 기반으로 vue는 동작된다.
  name: 'LeftSideWindow',
  components: {
    GaugeCard,
    VChart,
    DetailStatusPopup
  },
  provide: {
    [THEME_KEY]: 'light'
  },
  props: {
    sites: {
      type: Array,
      default: [
        {
          PVPCS_Pac: 100,
          PVPCS_Daily_P: 60,
          expectPrice: 80,
          totalCapacity: 100
        },
        {
          PVPCS_Pac: 100,
          PVPCS_Daily_P: 60,
          expectPrice: 80,
          totalCapacity: 100
        }
      ]
    },
    from: {
      type: Boolean,
      default: false
    },
    refresh: {
      type: Boolean,
      default: false
    },
    init: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      popup: false,
      paramList: [],
      searchText: '',
      chartMax: 30,
      coinImg: require('@/assets/image/monitoring/icon_coin.png'),
      bar: {
        title: {
          subtext: '실시간 당일 발전량',
          subtextStyle: {
            color: '#B5BDC7'
          }
        },
        xAxis: {
          type: 'category',
          data: [],
          show: false
        },
        grid: {
          x: 10,
          y2: 10,
          x2: 10
        },
        yAxis: {
          type: 'value',
          show: false
        },
        series: [{
          data: [],
          type: 'bar'
        }],
        tooltip: {
          trigger: 'axis',
          formatter: ' {b0} <br /> {c0} kW'
        }
      },
      refreshFlag: 0
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
    // let date = new Date()
    // for (let i = 0; i < this.chartMax; i++ ) {
    //   let add = i === 0 ? 0 : 1
    //   date.setMinutes(date.getMinutes() + add)
    //   this.bar.xAxis.data.push(day(date).format('YYYY-MM-DD HH:mm'))
    // }
  },
  watch: {
    refresh(newValue) {
      // this.addBarChart(this.total.pvpcsPac)
      this.refreshFlag++
    },
    init() {
      // this.bar.series[0].data = []
    }
  },
  mounted() {
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
  },
  computed: {
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
    installDate() {
      return day(this.infoData.date).format('YYYY년 MM월 DD일')
    },
    total() {
      let pvpcsPac = 0
      let pvpcsDailyP = 0
      let time = 0
      let capacity = 0
      let price = 0
      this.sites.forEach(x => {
        pvpcsPac += x.PVPCS_Pac
        pvpcsDailyP += x.PVPCS_Daily_P
        price += x.expectPrice
        capacity += x.totalCapacity
      })
      time = capacity !== 0 ? (pvpcsDailyP / capacity).toFixed(2) : 0
      pvpcsPac = pvpcsPac.toFixed(2)
      pvpcsDailyP = pvpcsDailyP.toFixed(2)
      price = this.numberWithCommas(price.toFixed(0))
      return {
        pvpcsPac, pvpcsDailyP, price, time, capacity
      }
    }
  },
  methods: {
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
    searchSite() {
      if (this.searchText !== '') {
        getSearchSite(this.searchText, store.state.user.userId).then(res => {
          this.paramList = res
          this.popup = true
        })
      } else {
        // Message.warn('검색어 입력!!')
      }
    },
    emitSearchSite(siteName) {
      this.searchText = siteName
      this.searchSite()
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      // return x.toString()
    },
    addBarChart(data) {
      if (this.bar.series[0].data.length === this.chartMax) {
        this.bar.series[0].data.shift()
        this.bar.series[0].data.push(data)
        let str = this.bar.xAxis.data[this.chartMax - 1]
        let date = new Date(str)
        date = date.setMinutes(date.getMinutes() + 2)
        this.bar.xAxis.data.shift()
        this.bar.xAxis.data.push(day(date).format('YYYY-MM-DD HH:mm'))
        // this.bar.xAxis.data.push()
      } else {
        this.bar.series[0].data.push(data)
      }
    }
  }
}
</script>

<style lang="less" scoped>
/* css 혹은 less로 스타일 정의하는 부분 */
/* 퍼블리셔 작업 영역 */

// lang="less"로 <style> 태그에 속성으로 넣어야 less를 사용할 수 있다.

.test-box {
  border: 1px solid lightgreen;
}
.ft{
  font-size: 35px!important;
}

</style>
